import * as BABYLON from "babylonjs/babylon.max";
import emscriptenRuntimeImport from "./dependencies.emsc.js";
import {
    GView, Line, Plane, Point, Quadric, RenderableMesh, Subline, Vector, Conic, Subplane
} from "./web/geom-objects/all-objects";
import {Parser} from "./web/parser";
import {colors, styles} from "./app-config/webapp-config.js";
import SampleDemo from "./web/app/test-load-sample";
import FileLoader from "./web/app/file-load";
import cabri from "./web/app/cabri-app.js";
import {actions, interpret, Machine} from "xstate";
import Vue from "vue";
import toolbar from "./web/tools/toolbar.js";
import {LOG} from "./web/app/log";
import cameraMethods from "./web/app/camera.js";


// debug oriented
import toolbarCmp from "./web/tools/toolbarCmp.vue";
import camera from "./web/app/camera";

console.log("Cabri starting...");

let initialize = async function () {
// next 2 properties to be used when asking for timing info in Cabrilog.log() with last parameter !== undefined
    LOG.timeCabriStarted = Date.now()        //  ~  new Date().getTime();
    LOG.previousTime     = LOG.timeCabriStarted
    console.log("Will wait for emscripten runtime import.");
    let ignored = await emscriptenRuntimeImport;
    console.log("Will wait for emscripten runtime.");
    const emscriptenRuntime = await window.emi;
    window.EmscriptenRuntime = emscriptenRuntime;
    console.log("Will call DEInitializedWeb.");
    emscriptenRuntime.DEIntializeWeb(true);

    const cabriInstance = new Cabri3D(emscriptenRuntime);
    await cabriInstance.init();
    window.cabri = cabri;

    // make classes public (i.e. in the window)
    window.Point = Point;
    window.Subline = Subline;
    window.Subplane = Subplane;
    window.Vector = Vector;
    window.Plane = Plane;
    window.Line = Line;
    window.Parser = Parser;
    window.RenderableMesh = RenderableMesh;
    window.Quadric = Quadric;
    window.GView = GView;
    window.Conic = Conic;
    window.BABYLON = BABYLON;

    /*
     window.PointOnSegment = PointOnSegment;
     window.VectorByTwoPoints = VectorByTwoPoints;
     window.SegmentByTwoPoints = SegmentByTwoPoints;
     window.FreePointOnPlane = FreePointOnPlane;
     window.FreePointOnLine = FreePointOnLine;
     */

    await FileLoader.initFile();
    console.log("File loaded.");
    try {
        cabri.emsc.operateAll();
    } catch (e) {
        console.warn(e);
    }

    cabri.gestureHandler.registerListeners();

    console.log("Emscripten runtime for Cabri3D: cabri.emsc=",
        window.EmscriptenRuntime);
    console.log(" - enjoy, e.g. using:");
    console.log("   - p = new Point(1,2,3) ");
    console.log("   - q = new Point(1,2,5) ");
    console.log("   - s = new Segment(p,q) ");
    console.log("   - console.log(p.z)");
    console.log("   - p.move(3,4,2)");

};

initialize(null);  // todo JML which semantic fro this NULL

class Cabri3D {
    constructor (emsc, className) {
        this.emsc = emsc;
        this.options = {};
        this.fileDirty = false;
        this.className = className;
        this.frameTime = Date.now()     // to keep the time when fps is displayed, then every 200 ms
    }

    async init () {
        await this.initConfig();       // add many colors  (JML not needed??
                                       // PL: to interpret all the traditional
                                       // names of cabri);  add styles
                                       // (actually cabri3D styles)
        await this.createCanvas();
        await this.createScene();
        window.cabri3Dinstance = this;
        for (let obj = this; obj != null; obj = Object.getPrototypeOf(obj)) {
            console.log("Visiting object ", obj);

            Object.getOwnPropertyNames(obj).map(prop => {
                cabri[prop] = obj[prop];
            });
        }
    }

    async initConfig () {
        this.colors = await colors;
        this.styles = await styles;
        this.highlightingActive = true;
    }

    createCanvas () {
        this.canvas = document.getElementById("cabri3dFigure");
        if(!this.canvas) {
            this.canvas = document.createElement("canvas");
            this.canvas.setAttribute("id", "renderCanvas");
            this.canvas.setAttribute("style",
                "width:100%; height:100%; touch-action:none; outline:0;");
            document.body.appendChild(this.canvas);
            const style = "overflow: hidden; width: 100%; height: 100%; margin: 0; padding: 0;";
            document.body.setAttribute("style", style);
            document.getRootNode().getElementsByTagName("html")[0].setAttribute(
                "style", style);
        }

/**** JML experiment 2021-11-26
        let _this= this
        this.canvas.addEventListener(
            "pointermove",
            function (evt) {
                _this.onPointerMove.call(_this, evt);
            }, false)
 JML experiment 2021-11-26  */
    }

/**** JML experiment 2021-11-26
    onPointerMove (evt) {
        let coords = {x:0,y:0}
        let selector = null
        const pickedArray = this.scene.multiPick(coords.x, coords.y, selector)    //  camera);
        let myevent = evt
    }
 JML experiment 2021-11-26  */


    async resetWithUrl (url) {
        cabri.scene.dispose();
        document.body.removeChild(cabri.canvas);
        for (let obj of cabri.allObjects) {
            if (obj && obj.dispose) {
                obj.dispose();
            }
        }
        cabri.emsc.reset();

        await SampleDemo.disable();
        await cabri.createCanvas();
        await cabri.createScene();
        await FileLoader.fileLoad(url);
        cabri.gestureHandler.registerListeners();
        cabri.toolbar.reset();
        cabri.emsc.operateAll();
    }

    createScene () {
        const canvas = this.canvas;

        let resizeCanvas = function () {
            let w = document.body.clientWidth,
                h = document.body.clientHeight;
            if (w > h)
                w = h;
            canvas.style.width = w + "px";
            canvas.style.height= w + "px";
        };
        //canvas.style.width  = 800+'px'
        //canvas.style.height = 800+'px'
        resizeCanvas();

        const engine = new BABYLON.Engine(canvas, true, {}, true);
        // Generate the BABYLON 3D engine (first true: antialias)
        window.addEventListener("resize", function () {
            resizeCanvas();
            engine.resize();
        });

        // Create the scene space
        let scene = new BABYLON.Scene(engine);
        cabri.scene = this.scene = scene;
        this.allObjects = [];

// ADD CAMERA  to the scene and attach it to the canvas
        let radius = 50;
        let camera = new BABYLON.ArcRotateCamera("Camera",
            Math.PI/12,
            Math.PI/3,
            radius,
            BABYLON.Vector3.Zero(),
            scene);

        // for a square scene camera.fovMode has no influence
        let fov = 2 * Math.atan(9 / radius);      // the size of the square
        // scene is ~ 18 cm
        camera.fov = fov;
        // fixing radius to a given value, say 50, would cancel zooming
        camera.lowerRadiusLimit = radius / 3;
        camera.upperRadiusLimit = radius * 3;
        //camera.angularSensibilityX = 180;           // lower means higher
        // sensibility  (default is 1000) camera.angularSensibilityY = 250;

        this.camera = camera;
        camera.getScreenUnitCoordFromXyz = cameraMethods.getScreenUnitCoordFromXyz;
        camera.setCameraProjection = cameraMethods.setCameraProjection;
        this.camera.autoRotate = null;

// ADD lIGHTS to the scene
        //scene.ambientColor = new BABYLON.Color3(1, 1, 1);  // default is
        // (0,0,0)
        scene.clearColor = new BABYLON.Color3(0.7, 0.7, 0.7);
        let hemiLight = new BABYLON.HemisphericLight("hslight",
            new BABYLON.Vector3(0, 1, 0), scene); // i.e. zenithal
        let k = 0.7;
        hemiLight.groundColor = new BABYLON.Color3(k, k, k); // to have gray
                                                             // light from
                                                             // below
        // groundColor light is reflected towards zenith
        hemiLight.intensity = 0.4;

        let pointLight = new BABYLON.PointLight("pointlight",
            new BABYLON.Vector3(50, 100, -100), scene);
        // x, z, y
        pointLight.parent = camera;    // this would be a torch... attached to the observer
        pointLight.intensity = 0.7;

        this.fpsDisplay();   // installs a div for displaying fps in Hz
        this.toolbar = toolbar;
        console.log("Initting toolbar...", toolbar);
// TOOLBAR
        const elt = document.createElement("div");
        const eltId = `toolbar`;
        elt.id = eltId;
        document.body.appendChild(elt);

        new Vue({render: h => h(toolbarCmp)}).$mount("#" + eltId);

        //window.startDemo = startDemo;

        // activate this line if needing to debug just the parser
        // if(false)
        let frameBegin, cdkDuration, renderBegin  // dates or duration for fps display below
        scene.registerBeforeRender(() => {
                frameBegin = Date.now()
                // list all objects
                let updateList = this.allObjects;
                // clear update bits
                for (let i of updateList) {
                    i.clearForCycleStart();
                }
                cabri.camera.setCameraProjection();
                // update each
                for (let i of updateList) {
                    i.updateFromPeer();
                }
                renderBegin =  Date.now()
                cdkDuration = renderBegin - frameBegin;

                if (cabri.camera.autoRotate !== null) {
                    const ar = cabri.camera.autoRotate;
                    if (ar.lastEventTime) {
                        const duration = new Date().getTime() - ar.lastEventTime;
                        const camera = cabri.camera;
                        camera.alpha = this.autoIncrementAngle(camera.alpha, duration * ar.dAlpha /3);
                        // not auto-animating beta for now
                        //camera.beta = this.autoIncrementAngle(camera.beta, duration * ar.dBeta /3);
                        //console.log("alpha, beta " + camera.alpha + " " + camera.beta);
                    }
                    ar.lastEventTime = new Date().getTime();
                }

            },
        );

        // Register a render loop to repeatedly render the scene
        let _this = this
        engine.runRenderLoop(function () {
            //renderBegin = Date.now()  // renderBegin already set in BeforeRender callback above
            cabri.scene.render();
            let elTime = renderBegin-_this.frameTime
            if (renderBegin-_this.frameTime > 200) {
                _this.frameTime = renderBegin
                let renderDuration = Date.now() - renderBegin;
                let fps = engine.getFps(), cFps = 999, gFps = 999
                if (cdkDuration > 1)
                    cFps = (1000 / cdkDuration).toFixed()
                cFps = (cFps<10)  ? "\u00A0\u00A0" + cFps :       // ~ &nbsp
                    ((cFps<100) ? "\u00A0" + cFps : cFps )

                if (renderDuration > 1)
                    gFps = (1000 / renderDuration).toFixed()
                gFps = (gFps<10)  ? "\u00A0\u00A0" + gFps :       // ~ &nbsp
                      ((gFps<100) ? "\u00A0" + gFps : gFps )

                // window.fpsDiv is defined just below in fpsDisplay ()
                window.fpsDiv.innerText = "sc: " +fps.toFixed()+ " c: " + cFps+ " g: "+gFps + " (Hz)";
            }
        });
        scene.useOrderIndependentTransparency = true;
        scene.depthPeelingRenderer.passCount = 2;  //i.e. 4 layers used to 5 (i.e. 10 layers)

        this.stdBlackMaterial = new BABYLON.StandardMaterial("csm", scene);
// color defaults are: a black(0,0,0), D white(1,1,1), e black, (0,0,0), S white(1,1,1)
        this.stdBlackMaterial.diffuseColor  = BABYLON.Color3.Black()
        //this.stdBlackMaterial.specularColor = BABYLON.Color3.Gray()
        this.stdBlackMaterial.specularColor = BABYLON.Color3.Black()
        // new Color3 object Black(),... Blue, Gray, Green, Magenta, Purple, Red, Teal, White, Yellow
// in Cabri it is best not to hav specular lighting up possibly to round objects
    } // ends createScene()

    autoIncrementAngle(angle, delta) {
        angle = angle + delta;
        if (angle > Math.PI) angle = angle-2*Math.PI;
        if (angle < -Math.PI) angle = angle+2*Math.PI;
        return angle;
    }

    notifyFileDirty () {
        if (this.fileDirty) {
            return;
        }
        this.fileDirty = true;
        if (window.bridge && window.bridge.isElectronApp) {
            window.bridge.fileDirty();
        }
    }

    saveFile () {
        console.log("Saving file");
        let content = cabri.emsc.getXMLForDocument();
        console.log(" ======= ", content, " ======== ");
        window.bridge.fileSave(content);

    }

// function to create a special div to display fps in Hz
    fpsDisplay () {
        if (window.fpsDiv)
            document.body.removeChild(window.fpsDiv);
        var d = window.fpsDiv = document.createElement("div");
        d.setAttribute("style",
            "font-family: monospace;" +
            "z-index: 10; position: absolute; color: white;"+
            "top: 0.1em; left: 0.1em; width: 20em; height: 1em;")
        document.body.appendChild(d);
    }

}

window.Machine = Machine;
window.actions = actions;
window.interpret = interpret;
window.Vue = Vue;
